<template>
  <header class="mb-6">
    <slot name="logo" />
    <h1 class="display-large text-textDarkest mt-2">
      <slot name="page-title" />
    </h1>
    <p class="below-title text-body-1 mt-2 text-center">
      <slot name="below-title" />
    </p>
  </header>
</template>

<style lang="less" scoped>
header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.below-title {
  color: @text-dark;

  :deep(a) {
    color: @link-default;
    text-decoration: underline;
  }
}
</style>
